"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreviousSectionInfo = void 0;
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var usePreviousSectionInfo = exports.usePreviousSectionInfo = function usePreviousSectionInfo() {
  var previousSection = (0, _exchangeReactHooks.usePreviousRoutesSectionId)();
  var previousPath = (0, _exchangeReactHooks.usePreviousRoutesSectionPath)();
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var homePath = getPath('home');
  if (!previousSection || previousSection === 'createAsset' || previousSection === 'newVersion') {
    return {
      action: 'Go to assets list',
      section: 'Assets list',
      path: homePath
    };
  }
  if (previousSection === 'home') {
    return {
      action: 'Back to assets list',
      section: 'Assets list',
      path: previousPath
    };
  }
  if (previousSection === 'topRankMetrics') {
    return {
      action: 'Back to metrics',
      section: 'Metrics',
      path: previousPath
    };
  }
  return {
    action: 'Back to previous',
    section: 'Back',
    path: previousPath
  };
};
//# sourceMappingURL=hooks.js.map